(function($) {

	$(function () {

		const $countdown = $('.js-countdown')
        
        if ($countdown.length) {
            $countdown.each(function() {
                initCountdown($(this))
            })
        }

        function initCountdown($self) {
            var dateUtc = $self.data('date-utc')

            if (!dateUtc) {
                $countdown.remove()
                return
            }

            var $days = $self.find('.js-countdown-days')
            var $hours = $self.find('.js-countdown-hours')
            var $minutes = $self.find('.js-countdown-minutes')
            var $seconds = $self.find('.js-countdown-seconds')
            
            var end = new Date(dateUtc.replace(/ /g, "T"))

            var _second = 1000
            var _minute = _second * 60
            var _hour = _minute * 60
            var _day = _hour * 24
            var timer

            function showRemaining() {
                var now = new Date()
                var distance = end - now
                if (distance < 0) {
                    clearInterval(timer)
                    $countdown.hide()
                    $('body').addClass('countdown-expired')
                    return
                }
                var days = Math.floor(distance / _day)
                var hours = Math.floor((distance % _day) / _hour)
                var minutes = Math.floor((distance % _hour) / _minute)
                var seconds = Math.floor((distance % _minute) / _second)

                var daysValue = ((days < 10 ? '0' : '') + days)
                var hoursValue = ((hours < 10 ? '0' : '') + hours)
                var minutesValue = ((minutes < 10 ? '0' : '') + minutes)
                var secondsValue = ((seconds < 10 ? '0' : '') + seconds)

                $days.html(`
                    <span>${daysValue[0]}</span>
                    <span>${daysValue[1]}</span>
                `)
                $hours.html(`
                    <span>${hoursValue[0]}</span>
                    <span>${hoursValue[1]}</span>
                `)
                $minutes.html(`
                    <span>${minutesValue[0]}</span>
                    <span>${minutesValue[1]}</span>
                `)
                $seconds.html(`
                    <span>${secondsValue[0]}</span>
                    <span>${secondsValue[1]}</span>
                `)
            }

            showRemaining()
            timer = setInterval(showRemaining, 1000)
        }

	})

})(window.jQuery)
